<template>
  <div class="app-card-report">
    <v-card flat>
      <div
        v-if="loading"
        class="progressive"
      >
        <v-progress-circular
          :size="40"
          class="progressbar-top-right"
          color="primary"
          indeterminate
        />
      </div>
      <v-icon
        v-if="highlight && !loading"
        color="yellow"
        class="mr-2"
      >
        star
      </v-icon>
      <v-tooltip
        v-if="tooltip && !loading"
        top
      >
        <v-icon
          slot="activator"
          class="info-card"
        >
          info_outline
        </v-icon>
        <span>
          {{ tooltip }}
        </span>
      </v-tooltip>
      <v-card-text>
        <div
          v-if="showLastWeek"
          class="date"
        >
          <span> Total dos últimos 7 dias: {{ item.lastWeek }} </span>
        </div>
        <div class="content">
          <div
            v-if="item.icon"
            class="icon"
          >
            <v-icon>{{ item.icon }}</v-icon>
          </div>
          <div>
            <span class="d-block card-report-title">
              {{ item.title }}
              <span class="card-report-complement">
                {{ item.complement }}
              </span>
            </span>
            <span class="d-block card-report-general">{{ item.general }}</span>
            <span
              v-if="item.sdzToBRL"
            >
              {{ item.sdzToBRL }}
            </span>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'AppCardReport',
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    loading: {
      type: Boolean,
      default: () => false
    },
    highlight: {
      type: Boolean,
      default: () => false
    },
    tooltip: {
      type: String,
      default: () => ''
    }
  },
  computed: {
    showLastWeek() {
      return typeof this.item.lastWeek !== 'undefined'
    }
  }
}
</script>

<style lang="stylus" scoped>
.progressbar-top-right
  position: absolute;
  top: 5px;
  right: 10px;
.v-card
  position relative
  flex-direction: column;
  justify-content: center;
  border: 1px solid #eee
  min-height: 160px
  display: flex
  align-items: center
  .v-icon
    align-self: flex-end;
  .content
    display: flex
    align-items: center
  .v-card__title
    border-bottom: none !important
    font-size: 13px
    padding: 10px
    color: #ccc
  .v-card__text
    .date
      position: absolute
      bottom: 13px
      right: 16px
      font-size: 11px
      color: #999
    .v-icon
      margin-right: 15px
      font-size: 33px
      height: 60px
      background: #f9f9f9
      width: 60px
      border-radius: 5px
      border: 1px solid #f8f8f8
      color: var(--v-primary-base) !important
    .card-report-title
      font-size: 15px
      margin-bottom: 10px
      color: var(--color-neutral-high-lightest)
    .card-report-complement
      font-size: 14px
      margin-bottom: 10px
      color: red
    .card-report-general
      font-weight: bold
      font-size: 16px
      color: var(--secondary-dark) !important
  .info-card
    position: absolute;
    top: 20px;
    left: 15px;
</style>
